import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=96cc7a2c&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=96cc7a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cc7a2c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96cc7a2c')) {
      api.createRecord('96cc7a2c', component.options)
    } else {
      api.reload('96cc7a2c', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=96cc7a2c&scoped=true&", function () {
      api.rerender('96cc7a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Projects.vue"
export default component.exports